import pb from '../lib/pocketbase';

export async function getIvivoOrders(page, perPage, filter = '') {
  return await pb.collection('ivivo_orders').getList(page, perPage, {
    sort: '-orderDate',
    filter,
    $autoCancel: false
  });
}

export async function createIvivoOrder(order) {
  return await pb.collection('ivivo_orders').create(order);
}

export async function updateIvivoOrder(id, order) {
  return await pb.collection('ivivo_orders').update(id, order);
}

export async function deleteIvivoOrder(id) {
  return await pb.collection('ivivo_orders').delete(id);
}

export async function getIvivoOrdersFull(filter = '') {
  return await pb.collection('ivivo_orders').getFullList({
    sort: '-orderDate',
    filter,
    $autoCancel: false
  });
} 